<template>
  <div id=bac>
    <mt-header title="银行预留信息认证">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
    </mt-header>

    <div id="bankcenter">
      <div>
        <span class="bankbzc">*注：预留手机号需为本人实名制的手机号</span>
        <a class="mint-cell mint-field"><!---->
          <div class="mint-cell-left"></div>
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title"><!----> <span class="mint-cell-text">银行卡账号</span> <!----></div>
            <div class="mint-cell-value">
              <input placeholder="请输入本人的银行卡号" :number="true" @keyup="validateNum"
                     v-model="bankApproval.bankcard" class="mint-field-core">
              <div class="mint-field-clear" style="display: none;"><i class="mintui mintui-field-error"></i></div>
              <span class="mint-field-state is-default"><i class="mintui mintui-field-default"></i></span>
              <div class="mint-field-other"></div>
            </div> <!----></div>
          <div class="mint-cell-right"></div>
        </a>
        <mt-field label="预留手机号" placeholder="请输入银行预留手机号" type="tel" v-model="bankApproval.mobile"></mt-field>
        <div class="yzmposition">
        <mt-field label="验证码" placeholder="请输入验证码" type="number" v-model="mobileCode"></mt-field>
        </div>
        <div class="yzmdiv">
          <button class="fr codebtn" :class="{cliac:flag}" @click="getCode()" v-bind:disabled="flag">{{codeValue}}
          </button>
        </div>
      </div>
      <div class="submitBut">
        <mt-button type="primary" size="large" @click="submitApproval" v-if="attestation!=='8'">提交认证</mt-button>
        <mt-button type="primary" size="large" @click="submitApprovalPersonal" v-else>提交信息</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {Toast, Actionsheet, Field, Indicator, Button} from 'mint-ui';
  import qs from "qs";
  var Base64 = require('@/js/base64.js');
  export default {
    name: 'approval',
    data () {
      return {
        bankApproval: {
          bankcard: "",
          mobile: "",
          realname: '',
          midCard: '',
          signCode: ''
        },
        _routerName: '',
        _routerPath: '',
        _selected: '',
        count: 60,
        codeValue: '获取验证码',
        flag: false,
        outTimer: '',
        mobileCode: "",
        attestation:''
      }
    },
    methods: {
      valiateData: function () {
        if (this.bankApproval.bankcard == "" || typeof(this.bankApproval.bankcard) == "undefined") {
          Toast("请输入银行卡号.");
          return false;
        }
		if (this.bankApproval.mobile == "" || typeof(this.bankApproval.mobile) == "undefined") {
          Toast("请输入银行卡预留手机号.");
          return false;
        }
        // if (this.bankApproval.signCode == "" || typeof(this.bankApproval.signCode) == "undefined") {
        //   Toast("请输入签约密码.");
        //   return false;
        // }
        var mobileReg = /^\d{11}$/;
        if (!mobileReg.test(this.bankApproval.mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }
        if (this.mobileCode.trim() == "" || typeof(this.mobileCode.trim()) == "undefined") {
          Toast("请输入验证码");
          return false;
        }
        return true;
      },
      // 输入银行卡号
      validateNum () {
        var bc = this.bankApproval.bankcard;
        this.bankApproval.bankcard = bc.replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
      },
      goBack(){
        let queryData={
            username: this.bankApproval.realname,
            userCardId:  this.bankApproval.midCard,
            signCode: this.bankApproval.signCode,
            _selected: this._selected,
            attestation:this.attestation,
        }
        const queryString = qs.stringify(queryData);
        const objBase64 = new Base64.Base64();
        const approvalInfo = objBase64.encode(queryString);

        this.$router.push({
          path: '/user/approval',
          query: {
            approvalInfo,
          }
        })
      },
      submitApproval () {
        var flag = this.valiateData(); // 验证输入框
        if (!flag) {
          return;
        }
        var _bankApprovalUrl = domain("_bankApproval");
        var formData = new FormData();
        //去除所有空格
        formData.append("bankcard", this.bankApproval.bankcard.replace(/\s*/g,""));
        formData.append("mobile", this.bankApproval.mobile.replace(/\s*/g,""));
        formData.append("realName", this.bankApproval.realname.replace(/\s*/g,""));
        formData.append("midCard", this.bankApproval.midCard.replace(/\s*/g,""));
        formData.append("mobileCode", this.mobileCode.replace(/\s*/g,""));
        var that = this;
        that.$http.post(
          _bankApprovalUrl,
          formData,
          {emulateJSON: true}
          )
          .then(function (response) {
            //接口返回数据,
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              Toast("认证成功.")
              this.$router.push({
                path: '/main',
                name: 'main',
                params: {
                  _selected: this._selected
                }
              });

            } else {
              Toast({
                message: msg
              });
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      submitApprovalPersonal(){
        var flag = this.valiateData(); // 验证输入框
        if (!flag) {
          return;
        }
        var _bankApprovalPersonal = domain("_bankApprovalPersonal");
        var formData = new FormData();
        formData.append("bankNo", this.bankApproval.bankcard.replace(/\s*/g,""));
        formData.append("phone", this.bankApproval.mobile.replace(/\s*/g,""));
        formData.append("mobileCode", this.mobileCode.replace(/\s*/g,""));
        formData.append("name", this.bankApproval.realname.replace(/\s*/g,""));
        formData.append("idCard", this.bankApproval.midCard.replace(/\s*/g,""));
        var that = this;

        that.$http.post(
          _bankApprovalPersonal,
          formData,
          {emulateJSON: true}
          )
          .then(function (response) {
            console.log(response);
            //接口返回数据,
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              Toast("认证成功.")
              this.$router.push({
                path: '/main',
                name: 'main',
                params: {
                  _selected: this._selected
                }
              });

            } else {
              Toast({
                message: msg
              });
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      getParams(){
        let queryData = this.$route.query;
        let objBase64 = new Base64.Base64();
        let params =qs.parse(objBase64.decode(queryData.approvalInfo));
        if (queryData == null) {
          return;
        }
        // let _router = params._router;
        // this._routerName = _router.name;
        // this._routerPath = _router.path;

        this.bankApproval.realname = params.username;
        this.bankApproval.midCard = params.userCardId;
        this.bankApproval.signCode = params.signCode;
        this._selected = params._selected;
        this.attestation=params.attestation;

        // this.$http.post(
        //   domain("_getMobile")
        // )
        //   .then(function(response){
        //     this.bankApproval.mobile = response.data.data.loginCode;
        //   },function(error){
        //     console.log(error);
        //   });
      },
      getCode: function () {
        var _mobile = this.bankApproval.mobile;
        if (_mobile == null || _mobile == "") {
          this.$toast('手机号不能为空.');
          return;
        }
        if(this.attestation=='8'){
          this.$http.post(
            domain("_getValidateCode"), {
              mobile: _mobile
            },
            )
            .then(function (response) {  //接口返回数据
              console.log(response)
              if (response.body.code == '0') {
                this.$toast('验证码已发送,请查收');
                this.settime();
              } else {
                this.$toast('获取验证码失败,请确认手机号');
              }
            }, function (error) {
            }
          )
        }else{
          this.$http.post(
          domain("_sendMsg"), {
            mobile: _mobile
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
          console.log(response)
            if (response.body.code == '0') {
              this.$toast('验证码已发送,请查收');
              this.settime();
            } else {
              this.$toast('获取验证码失败,请确认手机号');
            }
          }, function (error) {
          })
        }
      },
      settime: function () {
        var that = this;
        if (this.count == 0) {
          this.count = 60;
          this.flag = false;
          this.codeValue = '获取验证码';
          if (this.outTimer != null) {
            this.outTimer = null;
            return;
          }
        }
        this.flag = true;
        this.count--;
        this.codeValue = "重新发送(" + this.count + "s)";
        this.outTimer = setTimeout(function () {
          that.settime()
        }, 1000);
      }

    },
    components: {},
    mounted: function () {
      this.getParams();
    }
  }

</script>
<style>
  #bac {
    position: fixed;
    height: 100%;
    background-color: #ECECEC;
    width: 100%;
  }

  #bankcenter {
    width: 100%;
    position: inherit;
  }

  .submitBut {
    width: 80%;
    display: block;
    padding-left: 10%;
    margin-top: 20px
  }

  .yzmdiv {
    width: 100%;
    height: 20px;
    position: relative;
  }

  .codebtn {
    display: block;
    cursor: pointer;
    color: #1f74d8;
    position: absolute;
    z-index: 2;
    width: 90px;
    height: 46px;
    top: -47px;
    left: 100%;
    margin-left: -102px;
    text-align: right;
    border: 0;
    background-color: #ffffff;
  }
  .bankbzc{
    color: red;
    font-size: 0.7rem;
    margin: 5px 10px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/module/user/bankApproval.vue